import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FullCalendarModule } from '@fullcalendar/angular';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { NgxsStoragePluginModule, StorageOption } from '@ngxs/storage-plugin';
import { NgxsModule } from '@ngxs/store';
import { TextMaskModule } from 'angular2-text-mask';
import { NgxStripeModule } from 'ngx-stripe';

import { componentsShared } from './components';
import { directivesComponents } from './directives';
import { FilterMessagePipe, pipesComponents } from './pipes';
import {
    AuthState,
    BackButtonState,
    ClassesState,
    CloudState,
    EnumsState,
    ErrorsState,
    EventsState,
    GroupsState,
    HomeworkSchoolState,
    LoaderState,
    MealsState,
    MenuState,
    MessagingState,
    NurseryState,
    OrdersState,
    RepertoireState,
    SchoolsState,
    SchoolYearState,
    StripeState,
    UsersState,
    WalletState,
} from './store/state';

FullCalendarModule.registerPlugins([dayGridPlugin, interactionPlugin]);

@NgModule({
    imports: [
        CommonModule,
        NgxsModule.forFeature([
            AuthState,
            LoaderState,
            MenuState,
            UsersState,
            GroupsState,
            RepertoireState,
            MessagingState,
            SchoolsState,
            ClassesState,
            SchoolYearState,
            EnumsState,
            ErrorsState,
            BackButtonState,
            MealsState,
            WalletState,
            NurseryState,
            HomeworkSchoolState,
            EventsState,
            StripeState,
            CloudState,
            OrdersState,
        ]),
        NgxsStoragePluginModule.forRoot({
            storage: StorageOption.LocalStorage,
            key: [
                'auth.rememberMe',
                'auth.accessToken',
                'auth.refreshToken',
                'auth.dashboardSelected',
                'auth.currentUser',
                'auth.currentSchool',
                'users.custodies',
            ],
        }),
        NgxStripeModule,
        TranslateModule,
        ReactiveFormsModule,
        RouterModule,
        LocalizeRouterModule,
        NgxSliderModule,
        FullCalendarModule,
        TextMaskModule,
        NgSelectModule,
        FormsModule,
    ],
    declarations: [...componentsShared, ...pipesComponents, ...directivesComponents],
    exports: [
        ...componentsShared,
        ...pipesComponents,
        ...directivesComponents,
        CommonModule,
        TranslateModule,
        ReactiveFormsModule,
        FullCalendarModule,
        NgSelectModule,
    ],
    providers: [FilterMessagePipe],
})
export class SharedModule {}
